import AppConfig from '@/modules/core/client/app/config';

import '@/modules/core/client/core.client.module';

AppConfig.registerModule('cms', ['core']);

// config
require('@/modules/cms/client/config/cms.client.routes');
